import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';

export const styles = stylex.create({
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  dateLabel: {
    width: '160px',
    display: 'flex',
    gap: '8px',
    padding: '8px 16px',
    borderRadius: '8px',
    border: `1px solid ${colors.tertiaryBorder}`,
    fontSize: '14px',
    fonWeight: '400',
    marginLeft: '16px',
    color: colors.primaryText,
    lineHeight: '20px',
  },
  date: {
    width: '104px',
  },
});
